// THIS IS AN AUTO-GENERATED FILE. DO NOT EDIT IT DIRECTLY!
// RUN `gulp classmap` TO GET A NEW CONTENT.



const _classmap = {
};

export default _classmap;